import * as Sentry from "@sentry/react";
import { createRoot } from 'react-dom/client';

import App from './App';
import { initAnalytics } from './lib/analytics';

import './index.css';

// ── Product analytics (PostHog) initialization ─────────────────────────────
initAnalytics();

// ── Sentry initialization ─────────────────────────────────────────────────────
// A missing VITE_SENTRY_DSN is treated as a no-op so dev / CI don't require it.
const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (!sentryDsn) {
  console.warn(
    "[sentry] VITE_SENTRY_DSN is not set — browser error monitoring is disabled.",
  );
} else {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    // Performance tracing off per task scope — errors only
    tracesSampleRate: 0,
    integrations: [Sentry.browserTracingIntegration()],
  });
}

createRoot(document.getElementById('root')!).render(
  <Sentry.ErrorBoundary fallback={<p>An unexpected error occurred. Our team has been notified.</p>}>
    <App />
  </Sentry.ErrorBoundary>,
);
